import ContinueContnetModuleProgress from './ContinueContentModuleProgress';
import RedeemPartnerCode from './RedeemPartnerCode';

export default function ProsumerQueryParamsHandlers() {
  return (
    <>
      <ContinueContnetModuleProgress />
      <RedeemPartnerCode />
    </>
  );
}
